import type { FC } from 'react';
import subscriptionIcon from './subscription-icon.png';
export const SubscriptionIcon: FC = () => {
  return (
    <img src={subscriptionIcon} alt="subscription" width={20} height={20} />
  );
};
